<template>
  <div class="index">
    <navi :activeIndex="1" :activeSub="true"></navi>
    <div class="container">
      <div class="t1">
        VR头盔：
        <span class="t2">最新一代VIVE PRO</span>
      </div>
      <div class="c1">
        <img src="@/assets/yj_01.jpg" alt="">
        <div class="c2">
          <img class="img1" src="@/assets/yj_03.jpg" alt="">
          <div
            class="t3"
          >VIVE PRO 头显基于最先进的显示技术，能够引导用户产生身在虚拟环境中的感觉。在驾驶培训行业应用中，VR 头显能够营造毫米级的汽车驾驶真实场景模拟，从而训练出非常接近真实的车感。</div>
        </div>
      </div>
      <div class="t1 t11">
        核心硬件：
        <span class="t2">抗眩晕</span>七轴动感学车机
      </div>
      <div class="c1">
        <img src="@/assets/yj_02.jpg" alt="">
        <div class="c2">
          <img src="@/assets/yj_04.jpg" alt="">
          <div class="t3">
            通过自主研发优化算法，软硬件一体化协同， 将
            <span class="t2">眩晕率降低到3%</span>，满足商业推广要求。 而传统设备眩晕率高达85%，完全不可能达 到商业要求。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "Product",
  components: {
    Navi
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  /* background-color: rgb(43, 43, 51); */
}

.container {
  /* box-shadow: 0px 0px 6px #999; */
  width: 1200px;
  /* height: 500px; */
  margin: 120px auto;
}
.t1 {
  font-size: 44px;
  color: #333;
  text-align: left;
}
.t2 {
  color: #ea6841;
}
.t3 {
  width: 440px;
  font-size: 24px;
  text-align: left;
  line-height: 38px;
  color: #666;
}
.t11 {
  margin-top: 200px;
}
.c1 {
  margin-top: 60px;
}
.c2 {
  margin-left: 60px;
  display: inline-block;
}
@media only screen and (max-width: 800px) {
  .container {
    width: auto;
    margin: 60px 30px;
  }
  .t1 {
    font-size: 32px;
  }
  .t3 {
    width: 100%;
    font-size: 24px;
    text-align: left;
    line-height: 38px;
    color: #666;
  }
  .t11 {
    margin-top: 100px;
  }
  .c1 img {
    width: 100%;
  }
  .c2 {
    margin-left: 0px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue